import * as React from 'react';
import {ApplicationState} from "../../redux/reducers";
import {connect} from "react-redux"
import {updateServicios} from "../../redux/actions/servicioAdicionalActions";
import Tab from "@material-ui/core/Tab";
import TabContext from '@material-ui/lab/TabContext'
import TabPanel from '@material-ui/lab/TabPanel';
import {TabList} from "@material-ui/lab";
import NextButton from "../controls/NextButton";
import ServicioAdicionalLista from "../servicioAdicional/servicioAdicionalLista";
import {useState} from "react";
import {setSolicitudCopia} from "../../redux/actions/solicitudActions";
import {enums} from "../../enums/enums";
import {ServicioAdicional} from "../../entities/catalogos/ServicioAdicional";
import {useSnackbar} from "notistack";
import {ISolicitud, Solicitud} from "../../entities/solicitudes/Solicitud";
import {IHelp} from '../help/Help';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import swal from 'sweetalert2';
import { IUsuario } from '../../entities/catalogos/IUsuario';
import { setUsuario } from "../../redux/actions/usuarioActions";

interface OwnProps {
    siguienteSeccion: (estatusId: number, servicios: ServicioAdicional[] | undefined) => void
    cotizacionId: number
}

interface StateProps {
    usuario: IUsuario
    solicitud: ISolicitud
    solicitudCopia: Solicitud
    serviciosAdicionales: ServicioAdicional[]
    ayuda: IHelp
}

interface DispatchProps {
    updateServicios: typeof updateServicios
    setCotizacionCopia: typeof setSolicitudCopia
    setUsuario: typeof setUsuario
}

type Props = OwnProps & StateProps & DispatchProps

const SeccionServicioAdicional = ({
                                      siguienteSeccion,
                                      serviciosAdicionales,
                                      updateServicios,
                                      solicitudCopia,
                                      setCotizacionCopia,
                                      cotizacionId,
                                      usuario
                                  }: Props) => {
    const [servicios, setServicios] = useState<ServicioAdicional[]>(serviciosAdicionales);
    const [copiaServiciosSeleccionados, setCopiaServiciosSeleccionados] = useState<any[]>([]);

    const {enqueueSnackbar} = useSnackbar();
    const [tipoSolicitudActual, setTipoSolicitudActual] = useState<number>(0);

    //Actualiza la copia de la cotización con los servicios seleccionados para mostrarlos en el resumen
    const updateCotizacionCopia = (copiaServicios: ServicioAdicional[]) => {
        const nuevaCotizacion = new Solicitud(solicitudCopia);

        setTipoSolicitudActual(nuevaCotizacion.tipoSolicitud == "cotizacion" ? 0 : 1);
        //Agrega solo los servicios seleccionados a la copia de la cotización
        //setCopiaServicios(copiaServicios);
        nuevaCotizacion.SetServiciosAdicionales(copiaServicios);
        setCotizacionCopia(nuevaCotizacion);
    };

    //Actualiza los servicios con el servicio seleccionado
    const seleccionarServicio = (servicio: ServicioAdicional) => {
        const copiaServicios = servicios.map(s => s.id !== servicio.id ? s : servicio);
        copiaServiciosSeleccionados.push(servicio);
        copiaServicios.forEach((ser,i) => {
            copiaServiciosSeleccionados.forEach(sers=> {
                if(ser.id===sers.id){
                    copiaServicios[i]=sers;
                }
            });
        });
        setServicios(copiaServicios);
        setCopiaServiciosSeleccionados(copiaServiciosSeleccionados);
        updateCotizacionCopia(copiaServicios);
    };

    const servicioValido = (): boolean => {
        const servicioRequerido = servicios.some(e => !!e.esRequerido && !e.seleccionado);
        const servicioSinCantidad = servicios.some(e => e.CantidadInvalida());
        const servicioSinCosto = servicios.some(e => e.CostoInvalido());
        const retornoDocumentos = servicios.find(e => e.esRetornoDocumentos && e.seleccionado);
        const servicioSinDocumentos = retornoDocumentos != null && !retornoDocumentos?.documentos?.length
    if(tipoSolicitudActual==1){
        if (servicioRequerido || servicioSinCantidad || servicioSinCosto || servicioSinDocumentos) {
            let error = servicioRequerido ? traducirMessage(126) + " " : ""; // Favor de seleccionar los adicionales requeridos
            error += servicioSinCantidad ?
                traducirMessage(103) + " " : ""; // Favor de ingresar una cantidad en todos los servicios adicionales seleccionados
            error += servicioSinCosto ? traducirMessage(99) + " " : ""; // Favor de capturar un costo en la sección de adicionales
            error += servicioSinDocumentos ? traducirMessage(98) : ""; // Favor de capturar los retornos de documentos

            enqueueSnackbar(error, {variant: "error"});
            return false;
        }
    }
        return true;
    };

    const handleSiguienteSeccion = () => {
        let serviciosCheck = true;
        servicios.forEach(s => {
            if(s.seleccionado){
                if(!s.aplicaOrigen && !s.aplicaDestino){
                    swal.fire({
                        titleText: traducirMessage(11), // '¡Aviso!',
                        text: traducirMessage(291)+ " " + (localStorage.getItem("idioma") === 'en-US' ? s.etiquetaServicioAdicionalDto.nombre : s.nombre), // "Favor de seleccionar el check de Origen y/o Destino para el servicio : ",
                        type: 'warning',
                    });
                    serviciosCheck=false;
                    return;
                }
            }
        });
        if (servicioValido() && serviciosCheck) {
            updateServicios(servicios);
            //siguienteSeccion(enums.estatusSolicitud.markup, servicios);
            let usuarioInv = usuario.esInvitado;
            if(usuario.esInvitado){
                siguienteSeccion(enums.estatusSolicitud.tipoEnvio, servicios);
            }
            else{
                siguienteSeccion(enums.estatusSolicitud.datosCliente, servicios);
            }
        }
    };

    return (<>
        <TabContext value="1">
            <TabList indicatorColor="primary" textColor="primary" value="1">
                <Tab label={traducirLabel(5)} value="1"/>
            </TabList>

            <TabPanel value="1">
                {servicios.length > 0 ?
                    <>
                        <ServicioAdicionalLista esSeccionServicios={true} servicios={servicios}
                                                onSelect={seleccionarServicio}
                                                cotizacionId={cotizacionId}/>

                        <NextButton nextStep={handleSiguienteSeccion}/>
                    </>
                    :
                    <h5>
                        {/* Favor de Seleccionar Remitente y Destinatario */
                        traducirMessage(130)}
                    </h5>
                }
            </TabPanel>
        </TabContext>
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    solicitud: state.solicitud,
    solicitudCopia: state.solicitudCopia,
    serviciosAdicionales: state.serviciosAdicionales,
    ayuda: state.ayuda,
    usuario: state.usuario
});

const mapDispatchToProps = {
    updateServicios: updateServicios,
    setCotizacionCopia: setSolicitudCopia,
    setUsuario: setUsuario
};

export default connect(mapStateToProps, mapDispatchToProps)(SeccionServicioAdicional);
